import { SignIn } from "@clerk/clerk-react";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/sign-in/$")({
	validateSearch: (
		search: Record<string, unknown>,
	): { redirectTo?: string } => ({
		redirectTo:
			typeof search.redirectTo === "string" && search.redirectTo.length > 0
				? search.redirectTo
				: undefined,
	}),
	component: SignInPage,
});

function SignInPage() {
	const { redirectTo } = Route.useSearch();
	const forceRedirectUrl = redirectTo;
	const signUpUrl = redirectTo
		? `/sign-up?redirectTo=${encodeURIComponent(redirectTo)}`
		: "/sign-up";

	return (
		<div className="min-h-[calc(100vh-200px)] flex items-center justify-center py-12">
			<SignIn
				routing="path"
				path="/sign-in"
				// Keep the default app landing as fallback, but prefer redirectTo when present
				fallbackRedirectUrl="/app/select-organization"
				forceRedirectUrl={forceRedirectUrl}
				// Ensure switching to sign-up inside Clerk UI also preserves redirectTo
				signUpUrl={signUpUrl}
			/>
		</div>
	);
}
